// Helpers de imagen puros del visor de parque solar (sin estado, sin dependencias del motor de render).

// Convierte una cadena base64 en un Blob del contentType dado.
export function base64ToBlob(base64String, contentType) {
  const byteCharacters = atob(base64String)
  const byteArray = new Uint8Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i)
  }
  return new Blob([byteArray], { type: contentType })
}

// Convierte un dataURL PNG a un Blob JPEG (fondo blanco para reemplazar la transparencia).
export function convertToJpg(pngDataUrl, quality) {
  return new Promise((resolve) => {
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const ctx = canvas.getContext('2d')
      // Fondo blanco para reemplazar transparencia PNG
      ctx.fillStyle = '#FFFFFF'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0)
      canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality)
    }
    image.src = pngDataUrl
  })
}
